import { DateTime } from "luxon";

export const DATE_FIELDS = ["birthDate", "idCardValidDate"] as const;

/**
 * Serializuje datum pro API jako UTC půlnoc.
 * Nepoužívat toISO() – způsobuje posun dne v časových zónách (CET apod.).
 */
export const toDateOnlyISO = (
  value: DateTime | Date | string | null | undefined
): string | null | undefined => {
  if (value == null) return value === null ? null : undefined;

  if (DateTime.isDateTime(value)) {
    return value.toFormat("yyyy-MM-dd") + "T00:00:00.000Z";
  }

  if (value instanceof Date) {
    const dt = DateTime.fromJSDate(value);
    return dt.isValid ? dt.toFormat("yyyy-MM-dd") + "T00:00:00.000Z" : undefined;
  }

  if (typeof value === "string") {
    const match = value.match(/^\d{4}-\d{2}-\d{2}/);
    if (match) {
      return value.slice(0, 10) + "T00:00:00.000Z";
    }
    const dt = DateTime.fromISO(value);
    return dt.isValid ? dt.toFormat("yyyy-MM-dd") + "T00:00:00.000Z" : undefined;
  }

  return undefined;
};

export const convertToDate = (
  value: DateTime | Date | string | null | undefined
): string | undefined => {
  const result = toDateOnlyISO(value);
  return result ?? undefined;
};

export const convertToRequiredDate = (
  value: DateTime | Date | string | null | undefined,
  fieldName = "Date"
): string => {
  if (!value) throw new Error(`${fieldName} is required`);
  const result = toDateOnlyISO(value);
  if (result) return result;
  throw new Error(`${fieldName} could not be converted to DateTime`);
};
